import { render, staticRenderFns } from "./PaxSuggestion.vue?vue&type=template&id=28c0268a&"
import script from "./PaxSuggestion.vue?vue&type=script&lang=js&"
export * from "./PaxSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports